<template>
    <div id="app">
        <router-view />
        <depositPopup></depositPopup>
        <withdrawPopup></withdrawPopup>
        <bankSet></bankSet>
        <withdrawPwdSetPopup></withdrawPwdSetPopup>
        <loadingPopup></loadingPopup>
    </div>
</template>
<script>
import { getSysBaseConfig, telegramLogin } from '@/api/system'
import { getUserInfo } from '@/api/user'
// import { domain } from '@/common/http'
import { getPWAValue } from '@/api/pwa'
import { isPWA, getPlatform } from '@/utils'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import { applyTheme } from '@/themes'
export default {
    computed: {
        themeSkin() {
            return this.$store.getters.themeSkin
        }
    },
    created() {
        this.$i18n.locale = this.$store.getters.language
        applyTheme(this.themeSkin)
        const equipmentId = this.$store.state.system.equipmentId
        if (!equipmentId) this.getBrowserFingerprint()
    },
    watch: {
        themeSkin: {
            handler(themeSkin) {
                applyTheme(themeSkin)
            }
        }
    },
    mounted() {
        const that = this
        if (!this.$store.getters.invitCode && getPlatform() === 'ios' && isPWA()) this.getPWAValue()

        getSysBaseConfig().then((res) => {
            if (res.code) return
            const D = res.result
            this.$store.dispatch('system/setSysConfig', D)
            const allowedLanguages = String(D.countryList || '').split(',').map(language => language.trim()).filter(Boolean)
            const userLanguageAllowed = !allowedLanguages.length || allowedLanguages.includes(this.$store.getters.language)
            if (D.belongCountry && (D.disabledBelongCountry === 'disable' || !this.$store.state.system.userSetlanguage || !userLanguageAllowed)) {
                this.$store.dispatch('system/setLanguage', D.belongCountry)
                this.$i18n.locale = D.belongCountry
            }
            try {
                const link = document.querySelector("link[rel*='icon']")
                if (link) link.href = D.homeImageUrl
                // document.querySelector('meta[property="og:title"]').setAttribute('content', D.projectName)
                // document.querySelector('meta[property="og:url"]').setAttribute('content', domain)
                // document.querySelector('meta[property="og:image"]').setAttribute('content', D.homeLogoUrl)
                // document.querySelector('meta[property="og:description"]').setAttribute('content', D.projectName)
            } catch (e) {
                console.log(e)
            }
        })
        try {
            const token = this.$store.getters.token
            if (token) {
                getUserInfo().then((uInfo) => {
                    if (uInfo.code) return
                    that.$websocket.initWebSocket()
                })
            } else {
                this.$websocket.close()
            }
        } catch (e) {
            console.log(e)
        }
        try {
            let isInstallPWA = 2
            if ('serviceWorker' in navigator) {
                window.addEventListener('beforeinstallprompt', function (e) {
                    // 阻止默认提示弹出
                    e.preventDefault()
                    that.$store.dispatch('system/setIsShowDownAppNav', 1)
                    that.$store.dispatch('system/setIsSaveVersionDesktop', 1)
                    isInstallPWA = 1
                    console.log('PWA install prompt captured 55555')
                })
                if (isInstallPWA === 2) {
                    console.log('PWA已经安装666666')
                    if (getPlatform() === 'ios') return
                    that.$store.dispatch('system/setIsShowDownAppNav', 2)
                    that.$store.dispatch('system/setIsSaveVersionDesktop', 2)
                }
            } else {
                console.log('Service Worker 不受此浏览器支持')
                // that.$store.dispatch('system/setIsShowDownAppNav', 1)
                that.$store.dispatch('system/setIsSaveVersionDesktop', 2)
            }
        } catch (e) {
            console.log(e, 'PWA错误')
        }
        window.addEventListener('beforeunload', this.handleBeforeUnload)

        if (window.Telegram?.WebApp) that.telegramLogin()
        else document.querySelector('script[src*="telegram.org/js/telegram-web-app.js"]')?.addEventListener('load', this.telegramLogin, { once: true })
    },
    beforeDestroy() {
        window.removeEventListener('beforeunload', this.handleBeforeUnload)
        document.querySelector('script[src*="telegram.org/js/telegram-web-app.js"]')?.removeEventListener('load', this.telegramLogin)
    },
    methods: {
        handleBeforeUnload(event) {
            this.$websocket.close()
            console.log('Browser closing', event)
        },
        getPWAValue() {
            const that = this
            const userAgent = navigator.userAgent
            const params = { userAgent }
            getPWAValue(params).then((res) => {
                if (res.code) return
                const D = res.result
                that.$store.dispatch('user/setInvitCode', D.invitationCode)
                that.$store.dispatch('system/setPixel', D.trafficAcquisitionType)
                that.$store.dispatch('system/setTaId', D.taid)
                that.$store.dispatch('system/setClickId', D.clickId)
                that.$store.dispatch('user/setInvitCodeNum', 1)
                if (that.$store?.getters.invitCode && (!that.$store?.getters.token) && that.$store?.getters.invitCodeNum === 1) {
                    console.log(66666)
                    that.$store.dispatch('user/setInvitCodeNum', 2)
                    that.$store.dispatch('user/changeLoginType', 1)
                    that.$store.dispatch('user/setIsShowLoginPopup', true)
                }
            })
        },
        telegramLogin() {
            const WebApp = window.Telegram?.WebApp
            if (!WebApp) return
            WebApp.ready()
            const user = WebApp.initDataUnsafe?.user
            if (user) {
                this.$store.commit('user/SET_TOKEN', '')
                const initData = WebApp.initData
                const params = JSON.stringify({ initData: initData })
                telegramLogin(params).then((res) => {
                    if (res?.code === 0) {
                        this.$store.dispatch('user/setInvitCode', '')
                        this.$store.dispatch('system/setTelegramUserId', '')
                        this.$store.commit('user/SET_TOKEN', `${res.result.tokenHead} ${res.result.token}`)
                        this.$forceUpdate()
                        getUserInfo().then((uInfo) => {
                            if (uInfo.code) return
                            this.$websocket.initWebSocket()
                        })
                        this.$store.dispatch('user/setIsShowLoginPopup', false)
                    }
                    if (res?.code === 401) {
                        this.$store.dispatch('system/setTelegramUserId', res.result.telegramUserId)
                    }
                })
            }
        },
        async getBrowserFingerprint() {
            let browserFinger
            try {
                const fp = await FingerprintJS.load()
                const result = await fp.get()
                browserFinger = result.visitorId
            } catch (error) {
                browserFinger = 'default123456789'
            }
            this.$store.dispatch('system/setEquipmentId', browserFinger)
        }
    }
}
</script>
<style lang="scss">
@import '@/common/styles/viriables.scss';

#app {
    font-family: "Segoe UI", Tahoma, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: $font-color;
    min-height: 100vh;
    background-color: var(--theme-root-bg, #031735);
    background-image: var(--theme-page-bg);
    background-size: var(--theme-page-bg-size);
    background-position: var(--theme-page-bg-position);
    background-repeat: no-repeat, no-repeat, no-repeat;
}

html[data-device-nodesktop="0"] {
    body {
        ::-webkit-scrollbar {
            display: none;
        }
    }
}

.global-toast {
    border-radius: .2rem !important;
    box-sizing: border-box;
    border: .01rem solid transparent;
    padding: 1px !important;
    background-image:
        var(--theme-popup-box-bg),
        linear-gradient(135deg, var(--theme-input-focus-border), var(--theme-popup-box-border));
    background-origin: border-box;
    background-clip: content-box, border-box;
    box-shadow: var(--theme-popup-box-shadow) !important;
}
.global-toast .van-toast__text {
     color: var(--theme-bright-text);font-size: .3rem !important;
    margin: .3rem .4rem !important;
}

body {
    margin: 0 !important;
    background-color: var(--theme-root-bg, #031735);
    background-image: var(--theme-page-bg);
    background-size: var(--theme-page-bg-size);
    background-position: var(--theme-page-bg-position);
    background-repeat: no-repeat, no-repeat, no-repeat;
    background-attachment: fixed;

    ::-webkit-scrollbar {
        width: .08rem;
        height: .06rem;
    }

    ::-webkit-scrollbar-thumb {
        border-radius: .5rem;
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background-color: $border-input-color;
        // border: .05rem solid #0A0A0A;
    }

    ::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
        border-radius: 5px;
        background-color: transparent;
    }
    .van-nav-bar,
    .van-nav-bar__content,
    .van-dropdown-menu,
    .van-dropdown-item__content {
        background: var(--theme-header-bg);
         color: var(--theme-bright-text);height: .98rem;
    }

    .van-nav-bar .van-icon,
    .van-nav-bar__text,
    .van-nav-bar__title,
    .van-dropdown-menu__title {
         color: var(--theme-bright-text);}
}

html[data-theme="porcelain"] {
    body,
    #app {
        color: var(--theme-bright-text);
    }

    .van-nav-bar,
    .van-nav-bar__content,
    .van-dropdown-menu,
    .van-dropdown-item__content {
        color: var(--theme-bright-text);
    }

    .van-nav-bar .van-icon,
    .van-nav-bar__text,
    .van-nav-bar__title,
    .van-dropdown-menu__title {
        color: var(--theme-bright-text);
    }

    .sidebar-container .user-name,
    .sidebar-container .rate,
    .sidebar-container .moneyLabel,
    .sidebar-container .sidebar_lang_txt,
    .sidebar-container .sidebar_customerService > div {
        color: var(--theme-bright-text) !important;
    }

    .sidebar-container .user-code p,
    .sidebar-container .search_btn .txt,
    .sidebar-container .search_btn .iconfont,
    .sidebar-container .vip_progress span,
    .sidebar-container .menu_item,
    .sidebar-container .side-menu,
    .sidebar-container .sidebar-item {
        color: var(--theme-soft-text) !important;
    }

    .theme_select label,
    .theme_select select {
        color: var(--theme-bright-text);
    }

    .ant-input,
    .ant-input::placeholder,
    .van-field__control,
    .van-field__control::placeholder {
        color: var(--theme-bright-text) !important;
    }
}
@import '@/common/styles/design-refresh/index.scss';
@import '@/common/styles/skin-design.scss';
</style>
